import { render, staticRenderFns } from "./Requestlist.vue?vue&type=template&id=c213a974&scoped=true&"
import script from "./Requestlist.vue?vue&type=script&lang=ts&"
export * from "./Requestlist.vue?vue&type=script&lang=ts&"
import style0 from "./Requestlist.vue?vue&type=style&index=0&id=c213a974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c213a974",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VContainer,VDivider,VIcon,VSwitch})
